const displayHtml = html => {
  return {__html: html}
}

export default displayHtml